import React, { useEffect, useState } from 'react'

import { Dialog } from 'primereact/dialog'

import _ from 'lodash';
import { utils, writeFile } from 'xlsx';

import { Button, Table } from '../../../helpers'
import Tooltip from '../../../helpers/Tooltip';

import Loading from '../../../common/Loading';


const ErrorMsgsModal = (props) => {
    const { errorMessagesData, visibleErrorMessageModal, setVisibleErrorMessageModal, rateContractProducts, handleConfirmUploadFileSubmit, skipAndUpdateNotAllowed } = props

    const [isLoadingVisible, setIsLoadingVisible] = useState(false)
    const [visibleIndividualErrorModal, setVisibleIndividualErrorModal] = useState(false)

    const [errorMsgsMap, setErrorMsgsMap] = useState({})
    const [selectedErrorMsg, setSelectedErrorMap] = useState({})
    const [similarErrorMessagesList, setSimilarErrorMessagesList] = useState([])

    useEffect(() => {
        let errorMsgsMap = {}
        errorMessagesData.map(eachErrorMessage => {
            if (errorMsgsMap[`${eachErrorMessage.type} ${eachErrorMessage.field}`]){
                errorMsgsMap[`${eachErrorMessage.type} ${eachErrorMessage.field}`].push(eachErrorMessage)
            } else {
                errorMsgsMap[`${eachErrorMessage.type} ${eachErrorMessage.field}`] = [eachErrorMessage]
            }
        })
        setErrorMsgsMap(errorMsgsMap)
    }, [errorMessagesData])

    const handleView = (errorMsgMap) => {
        let relatedErrorMessagesList = errorMsgsMap[errorMsgMap]
    
        setVisibleIndividualErrorModal(true)
        setSelectedErrorMap(relatedErrorMessagesList[0])
        setSimilarErrorMessagesList(relatedErrorMessagesList)
    }

    const downloadErrorMessagesSheet = async () => {
        setIsLoadingVisible(true)
        let rateContractErrors = []
        if (errorMessagesData.length) {
            errorMessagesData.map(eachErrorMessage => {
                let updatedErrorMessage = {
                    'SR NO': eachErrorMessage.srNo,
                    'Error Field': eachErrorMessage.field,
                    'Given Value': eachErrorMessage.value,
                    'Error Type': eachErrorMessage.type,
                    'Detail': eachErrorMessage.detail
                }

                rateContractErrors.push(updatedErrorMessage)
            })
        }

        const worksheet = utils.json_to_sheet(rateContractErrors)
        const workbook = utils.book_new()
        utils.book_append_sheet(workbook, worksheet, "RateContracts ErrorSheet")
        writeFile(workbook, "rateContractsErrorSheet.xlsx")

        setIsLoadingVisible(false)
    }

    const errorMessageColumns = [
        {
            header: 'Sr No',
            field: 'srNo',
        },
        {
            header: 'Error',
            field: 'detail',
        },
    ]


    const renderHeader = () => {
        return(
            <div className="flex flex-row justify-content-between">
                <p>{`${errorMessagesData.length} ERRORS FOUND`}</p>
                <Tooltip target=".custom-target-icon" />
                <div className='m-2 mr-5 custom-target-icon' style={{height: '50%', cursor: 'pointer'}} onClick={() => downloadErrorMessagesSheet()} data-pr-tooltip='Download Errors Sheet' data-pr-position='right'>
                    <i className='pi pi-download' style={{fontWeight: 'bold', paddingRight: '10%'}}></i>
                </div>
            </div>
        )
    }

    return (
        <>
            <Dialog header={renderHeader} visible={visibleErrorMessageModal} style={{ width: '55vw', minHeight: "45%", padding: '20px' }} onHide={() => setVisibleErrorMessageModal(false)}>    
                <div className="">
                    <hr />
                    {
                        Object.keys(errorMsgsMap).map(eachMsgMap => {
                            let errorLength = errorMsgsMap[eachMsgMap].length
                            return (
                                <div className='flex flex-row'>
                                    <p style={{backgroundColor: 'red', height: '25px', width: '80px', textAlign: 'center', color: 'white', paddingTop: '5px'}}>{errorLength}</p>
                                    <p style={{paddingLeft: '1rem', paddingTop: '0.3rem', textAlign: 'center'}}>{`${errorMsgsMap[eachMsgMap][0]?.field} is ${errorMsgsMap[eachMsgMap][0]?.type}.`}</p>
                                    <div className="flex flex-row justify-content-end align-items-center mt-0 ml-3">
                                        <a className="mt-0" style={{ textDecoration: "none", color:"black", fontSize: "13px", fontWeight: 'bold', cursor: 'pointer'}} onClick={() => handleView(eachMsgMap)}>View Details</a>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                { !skipAndUpdateNotAllowed && <Button className="h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="skip and continue with price update" onClick={() => handleConfirmUploadFileSubmit(rateContractProducts, true)} /> }
            </Dialog>
            <Dialog header={`${selectedErrorMsg.field} ERRORS`} visible={visibleIndividualErrorModal} style={{ width: '60vw', minHeight: "35%" }} onHide={() => setVisibleIndividualErrorModal(false)}>
                <div className="">
                    <Table
                        tableColumns={errorMessageColumns}
                        data={similarErrorMessagesList}
                        scrollable={"true"}
                    />
                </div>
            </Dialog>
            <Loading visible={isLoadingVisible}/>
        </>
    
    )
}

export default ErrorMsgsModal